// Service detail page content (bilingual) keyed by slug
export const servicePages = {
  ro: {
    "social-media-management": {
      slug: "social-media-management",
      icon: "camera",
      eyebrow: "Social Media Management",
      title: "Social media care vinde, nu doar arată bine.",
      lead:
        "Construim prezențe premium pe Instagram, TikTok, Facebook și LinkedIn. Strategie, producție, publicare și community — tot ce ai nevoie ca să-ți transformi audiența în clienți.",
      intro_title: "Ce înseamnă management profesionist",
      intro_body:
        "Un simplu \"postăm 3 ori pe săptămână\" nu mai funcționează. Algoritmii filtrează agresiv, atenția e scăzută, iar brandurile care cresc sunt cele care spun povești. Echipa noastră lucrează pe trei piloni: poziționare, producție și performanță.",
      intro_image:
        "https://images.unsplash.com/photo-1611162617213-7d7a39e9b1d7?auto=format&fit=crop&w=1200&q=80",
      why_title: "De ce Social Destiny",
      why_points: [
        { title: "Echipă internă completă", desc: "Strategi, copywriteri, fotografi și video editori — toți sub același acoperiș." },
        { title: "Producție lunară premium", desc: "Shooting-uri planificate, cu estetică coerentă cu brandul tău." },
        { title: "Strategie măsurabilă", desc: "KPIs clari pe reach, engagement, profil views și conversii." },
        { title: "Reels & TikTok focus", desc: "Formatul care scalează organic în 2025 — noi îl stăpânim." },
      ],
      features_title: "Ce include pachetul",
      features: [
        { title: "Strategie editorială lunară", desc: "Calendar de content pe obiective și direcții creative." },
        { title: "Producție foto & video", desc: "2-4 shooting-uri lunar cu echipament profesional." },
        { title: "Copywriting premium", desc: "Captions care construiesc comunitate și vând subtil." },
        { title: "Publicare zilnică", desc: "Feed, stories, reels, tiktok — la ore optime pentru audiență." },
        { title: "Community management", desc: "Răspundem la DM-uri și comentarii în numele tău, în tonul brandului." },
        { title: "Raportare lunară", desc: "Cifre reale și insights care ghidează luna următoare." },
      ],
      cta_title: "Ești pregătit pentru un social media de calibru mare?",
      cta_subtitle: "Lucrăm cu un număr limitat de clienți simultan. Programează o discuție exploratorie.",
    },
    "ads": {
      slug: "ads",
      icon: "megaphone",
      eyebrow: "Campanii ADS",
      title: "ROAS peste piață. Clienți, nu click-uri.",
      lead:
        "Campanii performance pe Meta, Google, TikTok, LinkedIn și YouTube. De la primul test până la scalare agresivă, cu obsesie pentru rezultate reale în afacerea ta.",
      intro_title: "Performance marketing făcut cu cap",
      intro_body:
        "Nu rulăm campanii pe pilot automat. Fiecare cont primește audit săptămânal, teste creative active și ajustări pe audiențe. Raportarea e transparentă: vezi exact ce aduce bani și ce nu.",
      intro_image:
        "https://images.unsplash.com/photo-1563013544-824ae1b704d3?auto=format&fit=crop&w=1200&q=80",
      why_title: "De ce campaniile noastre aduc rezultate",
      why_points: [
        { title: "Structură optimizată pentru scalare", desc: "Construim conturi care pot crește de la 500€ la 50.000€/lună fără să se strice." },
        { title: "Creative testing săptămânal", desc: "Video, static, UGC — testăm constant ce mișcă acul." },
        { title: "Tracking impecabil", desc: "CAPI, GTM, evenimente offline — măsurăm tot ce se poate măsura." },
        { title: "Consultanță directă", desc: "Vorbești cu strategul, nu cu un call center. Răspundem în ore, nu în zile." },
      ],
      features_title: "Platforme pe care rulăm",
      features: [
        { title: "Meta Ads (Facebook & Instagram)", desc: "Cel mai mare driver de conversii pentru ecom și lead gen." },
        { title: "Google Ads & YouTube", desc: "Search, Shopping, Performance Max și YouTube pentru awareness." },
        { title: "TikTok Ads", desc: "Creative-first. Formatul care domină Gen Z și millennials." },
        { title: "LinkedIn Ads", desc: "B2B, recrutare și servicii high-ticket." },
        { title: "Landing pages & CRO", desc: "Feedback pe landing și A/B testing pentru rata de conversie." },
        { title: "Raportare săptămânală", desc: "Dashboards clare cu CAC, ROAS, LTV și recomandări pentru săptămâna următoare." },
      ],
      cta_title: "Ai buget și vrei să-l investești inteligent?",
      cta_subtitle: "O ședință strategică de 30 de minute și îți spunem exact ce merită testat.",
    },
    "website": {
      slug: "website",
      icon: "monitor",
      eyebrow: "Websites",
      title: "Website-uri care convertesc. Pe bune.",
      lead:
        "De la magazine online care scalează la 7 cifre, la site-uri de prezentare premium, la custom builds fără compromisuri. Tot ce ai nevoie ca afacerea ta să arate și să funcționeze impecabil online.",
      intro_title: "Un site nu e doar estetică. E infrastructură.",
      intro_body:
        "Un site frumos fără SEO nu e găsit. Un site rapid fără strategie nu convertește. Un ecom fără tracking nu scalează. Noi le gândim pe toate împreună: design, performance, SEO și integrare cu ads.",
      intro_image:
        "https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=1200&q=80",
      why_title: "De ce să ne alegi pentru site",
      why_points: [
        { title: "Design premium & unic", desc: "Fără template-uri generice. Fiecare site e gândit pentru brandul tău." },
        { title: "Performance obsesiv", desc: "Core Web Vitals verde, PageSpeed 90+, SEO tehnic impecabil." },
        { title: "Integrare completă", desc: "Analytics, CRM, email, ads pixels, CAPI — toate configurate de la start." },
        { title: "Suport post-lansare", desc: "Nu dispărem după go-live. Mentenanță, updates și optimizări continue." },
      ],
      features_title: "Serviciile noastre de web",
      features: [
        { title: "Magazine online & eCommerce", desc: "Shopify, WooCommerce sau custom. Site-uri care vând la volum și nu cad pe Black Friday." },
        { title: "WordPress premium", desc: "Site-uri custom pe WordPress, cu ACF, blocuri Gutenberg și tema proprie." },
        { title: "Dezvoltare custom", desc: "React, Next.js, Node — pentru proiecte care depășesc limitele template-urilor." },
        { title: "Optimizare SEO", desc: "On-page, technical SEO, content strategy și link building." },
        { title: "Audit website", desc: "Raport complet: UX, SEO, viteză, conversii. Cu plan de acțiune concret." },
        { title: "Întreținere & mentenanță", desc: "Updates lunare, backup, securitate și monitorizare 24/7." },
      ],
      cta_title: "Ai nevoie de un site care să te reprezinte cu adevărat?",
      cta_subtitle: "Trimite-ne proiectul. Revenim cu un plan și estimare în 48h.",
    },
    "consultanta": {
      slug: "consultanta",
      icon: "compass",
      eyebrow: "Consultanță Marketing",
      title: "Un creier strategic pentru afacerea ta.",
      lead:
        "Pentru fondatori și echipe interne care au nevoie de expertiză strategică fără să externalizeze tot. Sesiuni 1-la-1, audituri, strategii de creștere — pe termen scurt sau lunar.",
      intro_title: "Consultanță fără fluff",
      intro_body:
        "Lucrăm cu fondatori care au deja un produs validat și o echipă mică, dar le lipsește strategia clară de creștere. Ne așezăm la aceeași masă, analizăm business-ul și construim un plan pragmatic pentru următoarele 6-12 luni.",
      intro_image:
        "https://images.unsplash.com/photo-1600880292089-90a7e086ee0c?auto=format&fit=crop&w=1200&q=80",
      why_title: "Ce primești din colaborare",
      why_points: [
        { title: "Auditul complet al marketing-ului actual", desc: "Unde ești, ce funcționează, ce pierzi." },
        { title: "Strategie de creștere pe 6-12 luni", desc: "Cu prioritizare clară: ce facem întâi, ce amânăm." },
        { title: "Sesiuni săptămânale sau lunare", desc: "În funcție de ritm. Sincer, direct, acționabil." },
        { title: "Acces la toți specialiștii noștri", desc: "Dacă ai nevoie de o părere despre ads, SEO sau content, o ai." },
      ],
      features_title: "Formate de consultanță",
      features: [
        { title: "Sesiune de strategie one-off", desc: "3 ore intensive. Pleci cu un plan scris și next steps clare." },
        { title: "Consultanță lunară", desc: "Call săptămânal + disponibilitate între call-uri pe Slack/WhatsApp." },
        { title: "Audit marketing complet", desc: "Raport de 40+ pagini cu recomandări pe toate canalele." },
        { title: "Workshop pentru echipă", desc: "Formăm echipa ta internă pe strategii și procese." },
      ],
      cta_title: "Simți că ești blocat și ai nevoie de o perspectivă nouă?",
      cta_subtitle: "Prima conversație e gratuită și durează 30 de minute.",
    },
  },
  en: {
    "social-media-management": {
      slug: "social-media-management",
      icon: "camera",
      eyebrow: "Social Media Management",
      title: "Social media that sells, not just looks good.",
      lead:
        "We build premium presences on Instagram, TikTok, Facebook and LinkedIn. Strategy, production, publishing and community — everything you need to turn your audience into customers.",
      intro_title: "What professional management really means",
      intro_body:
        "A simple \"we post 3 times a week\" doesn't cut it anymore. Algorithms filter aggressively, attention is scarce, and the brands that grow are the ones telling stories. Our team works on three pillars: positioning, production, and performance.",
      intro_image:
        "https://images.unsplash.com/photo-1611162617213-7d7a39e9b1d7?auto=format&fit=crop&w=1200&q=80",
      why_title: "Why Social Destiny",
      why_points: [
        { title: "Full in-house team", desc: "Strategists, copywriters, photographers and video editors — all under one roof." },
        { title: "Premium monthly production", desc: "Planned shoots with visual consistency tailored to your brand." },
        { title: "Measurable strategy", desc: "Clear KPIs on reach, engagement, profile views and conversions." },
        { title: "Reels & TikTok focus", desc: "The format that scales organically in 2025 — we've mastered it." },
      ],
      features_title: "What's included",
      features: [
        { title: "Monthly editorial strategy", desc: "Content calendar aligned to objectives and creative directions." },
        { title: "Photo & video production", desc: "2-4 shoots per month with professional gear." },
        { title: "Premium copywriting", desc: "Captions that build community and sell subtly." },
        { title: "Daily publishing", desc: "Feed, stories, reels, TikTok — posted at optimal times." },
        { title: "Community management", desc: "We reply to DMs and comments in your brand voice." },
        { title: "Monthly reporting", desc: "Real numbers and insights that guide the next month." },
      ],
      cta_title: "Ready for high-caliber social media?",
      cta_subtitle: "We work with a limited number of clients at a time. Book an exploratory call.",
    },
    "ads": {
      slug: "ads",
      icon: "megaphone",
      eyebrow: "ADS Campaigns",
      title: "ROAS above market. Customers, not clicks.",
      lead:
        "Performance campaigns on Meta, Google, TikTok, LinkedIn and YouTube. From the first test to aggressive scaling, obsessed with real results for your business.",
      intro_title: "Performance marketing done right",
      intro_body:
        "We don't run campaigns on autopilot. Every account gets a weekly audit, active creative tests, and audience adjustments. Reporting is transparent: you see exactly what brings money and what doesn't.",
      intro_image:
        "https://images.unsplash.com/photo-1563013544-824ae1b704d3?auto=format&fit=crop&w=1200&q=80",
      why_title: "Why our campaigns deliver",
      why_points: [
        { title: "Structure optimised for scale", desc: "We build accounts that can grow from €500 to €50k/month without breaking." },
        { title: "Weekly creative testing", desc: "Video, static, UGC — constantly testing what moves the needle." },
        { title: "Impeccable tracking", desc: "CAPI, GTM, offline events — we measure everything measurable." },
        { title: "Direct consulting", desc: "You talk to the strategist, not a call centre. Replies in hours, not days." },
      ],
      features_title: "Platforms we run",
      features: [
        { title: "Meta Ads (Facebook & Instagram)", desc: "The biggest conversion driver for ecom and lead gen." },
        { title: "Google Ads & YouTube", desc: "Search, Shopping, Performance Max and YouTube for awareness." },
        { title: "TikTok Ads", desc: "Creative-first. The format dominating Gen Z and millennials." },
        { title: "LinkedIn Ads", desc: "B2B, recruitment and high-ticket services." },
        { title: "Landing pages & CRO", desc: "Landing page feedback and A/B testing for conversion rate." },
        { title: "Weekly reporting", desc: "Clear dashboards with CAC, ROAS, LTV and next week's recommendations." },
      ],
      cta_title: "Got budget and want to spend it smartly?",
      cta_subtitle: "A 30-minute strategy call and we'll tell you exactly what's worth testing.",
    },
    "website": {
      slug: "website",
      icon: "monitor",
      eyebrow: "Websites",
      title: "Websites that actually convert.",
      lead:
        "From online stores scaling to 7 figures, to premium presentation sites, to no-compromise custom builds. Everything you need so your business looks and performs flawlessly online.",
      intro_title: "A site isn't just aesthetics. It's infrastructure.",
      intro_body:
        "A pretty site without SEO won't be found. A fast site without strategy won't convert. An ecom without tracking won't scale. We think about all of them together: design, performance, SEO and ad integration.",
      intro_image:
        "https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=1200&q=80",
      why_title: "Why pick us for your site",
      why_points: [
        { title: "Premium & unique design", desc: "No generic templates. Every site built for your brand." },
        { title: "Performance obsession", desc: "Green Core Web Vitals, PageSpeed 90+, impeccable technical SEO." },
        { title: "Full integration", desc: "Analytics, CRM, email, ad pixels, CAPI — all set up from day one." },
        { title: "Post-launch support", desc: "We don't disappear after go-live. Maintenance, updates and ongoing optimisation." },
      ],
      features_title: "Our web services",
      features: [
        { title: "eCommerce & online stores", desc: "Shopify, WooCommerce or custom. Sites that sell at volume and survive Black Friday." },
        { title: "Premium WordPress", desc: "Custom WP builds with ACF, Gutenberg blocks and bespoke themes." },
        { title: "Custom development", desc: "React, Next.js, Node — for projects that outgrow templates." },
        { title: "SEO optimisation", desc: "On-page, technical SEO, content strategy and link building." },
        { title: "Website audit", desc: "Complete report: UX, SEO, speed, conversions — with a concrete action plan." },
        { title: "Maintenance & care", desc: "Monthly updates, backups, security and 24/7 monitoring." },
      ],
      cta_title: "Need a site that truly represents you?",
      cta_subtitle: "Send us your project. We'll come back with a plan and estimate within 48h.",
    },
    "consultanta": {
      slug: "consultanta",
      icon: "compass",
      eyebrow: "Marketing Consulting",
      title: "A strategic brain for your business.",
      lead:
        "For founders and in-house teams who need strategic expertise without outsourcing everything. 1-on-1 sessions, audits, growth strategies — short term or monthly.",
      intro_title: "Consulting without fluff",
      intro_body:
        "We work with founders who have a validated product and a small team but lack a clear growth strategy. We sit at the same table, analyse the business and build a pragmatic plan for the next 6-12 months.",
      intro_image:
        "https://images.unsplash.com/photo-1600880292089-90a7e086ee0c?auto=format&fit=crop&w=1200&q=80",
      why_title: "What you get",
      why_points: [
        { title: "Full audit of current marketing", desc: "Where you are, what works, what's leaking." },
        { title: "6-12 month growth strategy", desc: "Clear prioritisation: what to do first, what to defer." },
        { title: "Weekly or monthly sessions", desc: "Based on rhythm. Honest, direct, actionable." },
        { title: "Access to our specialists", desc: "Need an opinion on ads, SEO or content? You've got it." },
      ],
      features_title: "Consulting formats",
      features: [
        { title: "One-off strategy session", desc: "3 intensive hours. You leave with a written plan and clear next steps." },
        { title: "Monthly retainer", desc: "Weekly call + between-call availability on Slack/WhatsApp." },
        { title: "Full marketing audit", desc: "40+ page report with recommendations across all channels." },
        { title: "Team workshop", desc: "We train your in-house team on strategy and processes." },
      ],
      cta_title: "Feeling stuck and need a fresh perspective?",
      cta_subtitle: "First conversation is free and takes 30 minutes.",
    },
  },
};

export const serviceMenu = {
  ro: [
    { slug: "social-media-management", label: "Social Media Management", desc: "Content premium, strategie și community." },
    { slug: "ads", label: "Campanii ADS", desc: "Meta, Google, TikTok, LinkedIn, YouTube." },
    { slug: "website", label: "Website", desc: "eCommerce, WordPress, custom & SEO." },
    { slug: "consultanta", label: "Consultanță Marketing", desc: "Strategie 1-la-1 pentru founderi și echipe." },
  ],
  en: [
    { slug: "social-media-management", label: "Social Media Management", desc: "Premium content, strategy and community." },
    { slug: "ads", label: "ADS Campaigns", desc: "Meta, Google, TikTok, LinkedIn, YouTube." },
    { slug: "website", label: "Websites", desc: "eCommerce, WordPress, custom & SEO." },
    { slug: "consultanta", label: "Marketing Consulting", desc: "1-on-1 strategy for founders and teams." },
  ],
};
